document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-academy-search]').forEach(function (root) {
    const input = root.querySelector('[data-academy-search-input]');
    const resultsEl = root.querySelector('[data-academy-search-results]');
    const dataEl = root.querySelector('[data-academy-search-data]');
    if (!input || !resultsEl || !dataEl) return;

    let articles = [];
    try {
      articles = JSON.parse(dataEl.textContent);
    } catch (e) {
      articles = [];
    }

    let activeMatches = [];

    function escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }

    function render(matches) {
      activeMatches = matches;
      if (!matches.length) {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        return;
      }
      resultsEl.innerHTML = matches
        .map(function (article) {
          return '<a href="' + encodeURI(article.url) + '">' + escapeHtml(article.title) + '</a>';
        })
        .join('');
      resultsEl.hidden = false;
    }

    input.addEventListener('input', function () {
      const query = input.value.trim().toLowerCase();
      if (!query) {
        render([]);
        return;
      }
      const matches = articles.filter(function (article) {
        return article.title.toLowerCase().indexOf(query) !== -1;
      }).slice(0, 6);
      render(matches);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && activeMatches.length) {
        e.preventDefault();
        window.location.href = activeMatches[0].url;
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        resultsEl.hidden = true;
      }
    });

    input.addEventListener('focus', function () {
      if (activeMatches.length) resultsEl.hidden = false;
    });
  });
});
